import { SearchOutlined } from '@ant-design/icons';
import { Card, Form, Input, Space } from 'antd';
import NumberInput from 'app/components/NumberInput/NumberInput';
import CultureSelect from 'app/components/Select/CultureSelect/CultureSelect';
import RecipeCategorySelect from 'app/components/Select/RecipeCategorySelect/RecipeCategorySelect';
import UserSelect from 'app/components/Select/UserSelect/UserSelect';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IRecipeFilters } from '../../types';

interface IProps {
  onFiltersChange: React.Dispatch<React.SetStateAction<IRecipeFilters>>;
  filters: IRecipeFilters;
}

const RecipeFilters: FC<IProps> = ({ onFiltersChange, filters }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card title={t('TransportFilters.Title', 'Filters')} bordered={false}>
      <Form
        layout="vertical"
        form={form}
        initialValues={{ layout: 'vertical' }}
        requiredMark={true}
        id="recipeFiltersForm"
        onValuesChange={(_, values: IRecipeFilters) => onFiltersChange(values)}
      >
        <Form.Item name="name">
          <Input
            prefix={<SearchOutlined />}
            placeholder={t('TransportFilters.Search', 'Search')}
          />
        </Form.Item>

        <Form.Item name="cultureIds">
          <CultureSelect mode="multiple" />
        </Form.Item>

        <Form.Item name="categoryIds">
          <RecipeCategorySelect mode="multiple" />
        </Form.Item>

        <Form.Item name="userId">
          <UserSelect placeholder={t('Recipe.Creator', 'Creator')} />
        </Form.Item>

        <Space>
          <Form.Item name="bbchFrom">
            <NumberInput placeholder={t('Recipe.BbchFrom', 'BBCH from')} />
          </Form.Item>

          <Form.Item name="bbchTo">
            <NumberInput placeholder={t('Recipe.BbchTo', 'BBCH to')} />
          </Form.Item>
        </Space>
      </Form>
    </Card>
  );
};

export default RecipeFilters;
